import { FC } from 'react'
import { ManageAccount } from '../ManageAccount/ManageAccount'
import { VerifyEmail } from '../VerifyEmail/VerifyEmail'
import { ChangeName, ChangeNameProps } from '../ChangeName/ChangeName'
import { ChangeEmail } from '../ChangeEmail/ChangeEmail'
import { DeleteAccount } from '../DeleteAccount/DeleteAccount'
import {
    ChangePassword,
    ChangePasswordProps,
} from '../ChangePassword/ChangePassword'
import { DeleteAccountAcknowledge } from '../DeleteAccount/DeleteAccountAcknowledge'
import { DeleteAccountPassword } from '../DeleteAccount/DeleteAccountPassword'

export type ScreenType =
    | 'manage-account'
    | 'verify-email'
    | 'change-name'
    | 'change-email'
    | 'change-password'
    | 'delete-account'
    | 'delete-account-acknowledge'
    | 'delete-account-password'
// | 'email-preference'

interface screenConfig {
    messageText?: string
    headingText: string
    subHeadingText?: string
    // If a parent is provided, it'll use this to navigate and get the back text.
    parent?: ScreenType
    // We want to utilise nav text variable for the top level for mobile devices that have
    // it being displayed in two layers.
    navText?: string
    body: FC<ChangeNameProps | ChangePasswordProps>
}

export const screens: Record<ScreenType, screenConfig> = {
    'manage-account': {
        navText: 'Settings',
        messageText: undefined,
        headingText: 'Manage account',
        body: ManageAccount,
    },
    'verify-email': {
        navText: 'Settings',
        headingText: 'Verify your email',
        parent: 'manage-account',
        body: VerifyEmail,
    },
    'change-password': getManageAccountChild('Change password', ChangePassword),
    'change-name': getManageAccountChild('Change name', ChangeName),
    'change-email': getManageAccountChild(
        'Change email',
        ChangeEmail,
        'Edit or change your email.',
    ),
    'delete-account': getManageAccountChild(
        'Delete your account',
        DeleteAccount,
    ),
    'delete-account-acknowledge': {
        navText: 'Delete account',
        headingText: 'Permanently delete your account?',
        parent: 'delete-account',
        body: DeleteAccountAcknowledge,
    },
    'delete-account-password': {
        navText: 'Delete account',
        headingText: 'Enter your password to delete your account',
        parent: 'delete-account-acknowledge',
        body: DeleteAccountPassword,
    },
}

function getManageAccountChild(
    headingText: string,
    body: FC<ChangeNameProps>,
    subHeadingText?: string,
    messageText?: string,
): screenConfig {
    return {
        headingText,
        subHeadingText,
        parent: 'manage-account',
        body,
        messageText,
    }
}
